<template>
  <div style="margin: 16px 0; padding: 10px">
    <div class="ut-flex ut-text-secondary">
      <span>{{$t('available_datapoints')}}</span>
    </div>
    <div class="ut-flex" style="margin-top: 10px; margin-bottom: 25px">
      {{datapoints}}
    </div>
    <hr style="border-top: 1px solid var(--sprt-85); border-bottom: none" />
    <div class="ut-flex ut-text-secondary" style="margin: 10px 0">
      <span>{{$t('location_of_function')}}</span>
    </div>
    <!-- <div style="width:100%; height:auto; border: 1px solid var(--sprt-85);border-radius: 10px; overflow: hidden;-webkit-transform: translateZ(0);-moz-border-radius:10px;-webkit-border-radius:10px;"> -->
    <video
      controls
      width="100%"
      style="
        border: 1px solid var(--sprt-85);
        border-radius: 10px;
        -moz-border-radius: 10px;
        -webkit-border-radius: 10px;
      "
    >
      <source
        :src="videoSrc"
        type="video/mp4"
      />
    </video>
    <!-- </div> -->
  </div>
</template>
<script>
export default {
  props: ["datapoints", "videoSrc"],
};
</script>
